import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36f6b218"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sleutels", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Handzenders", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Weer tijdens oplevering:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Opmerking(en) over het weer:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Algemene opmerking(en) over de oplevering:", -1))

import { deliveryStore } from '@/stores/delivery'
import DeliveryGeneralCheckRow from '@/components/delivery/DeliveryGeneralCheckRow.vue'
import axios from 'axios'
import { computed, onMounted } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryGeneralChecksCard',
  setup(__props) {

const lastInstallmentPaid = computed(() => deliveryStore().delivery && deliveryStore().delivery.building.last_installment_paid)

onMounted(() => {
  if (!deliveryStore().deliveryClosed) {
    getWeatherInfo()
    if (!lastInstallmentPaid.value) {
      deliveryStore().delivery.general_checks.note = 'Sleutels NIET overgedragen omdat laatste termijnfactuur nog niet was voldaan ten tijde van deze oplevering.'
    }
  }
})

function valueChanged (field:string, value:boolean) : void {
  deliveryStore().delivery.general_checks[field] = value
  deliveryStore().updateDelivery('general_checks', deliveryStore().delivery.general_checks)
}

function getWeatherInfo () : void {
  axios.get('https://weerlive.nl/api/json-data-10min.php?key=ac5abc56bb&locatie=' + deliveryStore().delivery.building.city, { headers: { Authorization: null, 'X-Requested-With': null } }).then((r) => {
    const weather = r.data.liveweer[0]
    if (weather.plaats !== 'None') {
      deliveryStore().delivery.general_checks.weather = weather.image
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Algemene controlepunten",
    bordered: false
  }, {
    default: _withCtx(() => [
      _createVNode(DeliveryGeneralCheckRow, {
        label: "Koper is geattendeerd op de aanwezigheid van dragende- / constructieve wanden. Aanpassingen daaraan mogen niet worden verricht zonder goedkeuring van een constructeur en geschiedt op eigen risico en initiatief van de koper.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.bearing_walls,
        onValueChanged: _cache[0] || (_cache[0] = ($event: any) => (valueChanged('bearing_walls', $event)))
      }, null, 8, ["currentValue"]),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "De erfafscheidingen zijn duidelijk aangeven door middel van piketpaaltjes.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.boundries,
        onValueChanged: _cache[1] || (_cache[1] = ($event: any) => (valueChanged('boundries', $event)))
      }, null, 8, ["currentValue"]),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "Het tegelwerk, de badkameraccessoires, het sanitair, de kozijnen, deuren, ramen en beglazing zijn schoon opgeleverd aan de koper en tijdens de oplevering op beschadigingen gecontroleerd.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.clean,
        onValueChanged: _cache[2] || (_cache[2] = ($event: any) => (valueChanged('clean', $event)))
      }, null, 8, ["currentValue"]),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "Koper heeft alle sleutels en handzender(s) in ontvangst genomen.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.all_keys_received,
        disabled: !_unref(lastInstallmentPaid),
        onValueChanged: _cache[3] || (_cache[3] = ($event: any) => (valueChanged('all_keys_received', $event)))
      }, null, 8, ["currentValue", "disabled"]),
      (!_unref(lastInstallmentPaid))
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            gutter: [16,16]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 18, offset: 6},
                sm: {span: 18, offset: 6},
                md: {span: 18, offset: 6},
                lg: {span: 22, offset: 2}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_alert, {
                    message: "Let op!",
                    description: "De sleutels mogen niet worden overgedragen omdat de laatste termijnfactuur nog niet is voldaan.",
                    type: "warning",
                    "show-icon": ""
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 18, offset: 6},
            sm: {span: 18, offset: 6},
            md: {span: 18, offset: 6},
            lg: {span: 22, offset: 2}
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_a_row, {
                gutter: [32, 16],
                class: "no-mb"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { class: "delivery-general-check-key-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hoofdsleutels:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 16}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                type: "number",
                                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || !_unref(lastInstallmentPaid),
                                value: _unref(deliveryStore)().delivery.general_checks.keys.main,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.keys.main) = $event)),
                                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { class: "delivery-general-check-key-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Raamboom:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 16}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                type: "number",
                                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || !_unref(lastInstallmentPaid),
                                value: _unref(deliveryStore)().delivery.general_checks.keys.window_handle,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.keys.window_handle) = $event)),
                                onBlur: _cache[7] || (_cache[7] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { class: "delivery-general-check-key-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Lichtkoepel:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 16}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                type: "number",
                                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || !_unref(lastInstallmentPaid),
                                value: _unref(deliveryStore)().delivery.general_checks.keys.skylight,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.keys.skylight) = $event)),
                                onBlur: _cache[9] || (_cache[9] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { class: "delivery-general-check-key-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Garage:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 16}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                type: "number",
                                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || !_unref(lastInstallmentPaid),
                                value: _unref(deliveryStore)().delivery.general_checks.keys.garage,
                                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.keys.garage) = $event)),
                                onBlur: _cache[11] || (_cache[11] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { class: "delivery-general-check-key-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Buitenkraan:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 16}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                type: "number",
                                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || !_unref(lastInstallmentPaid),
                                value: _unref(deliveryStore)().delivery.general_checks.keys.outside_tap,
                                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.keys.outside_tap) = $event)),
                                onBlur: _cache[13] || (_cache[13] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 18, offset: 6},
            sm: {span: 18, offset: 6},
            md: {span: 18, offset: 6},
            lg: {span: 22, offset: 2}
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_a_row, { gutter: [32, 16] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { class: "delivery-general-check-key-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Garage:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 16}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                type: "number",
                                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || !_unref(lastInstallmentPaid),
                                value: _unref(deliveryStore)().delivery.general_checks.receivers.garage,
                                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.receivers.garage) = $event)),
                                onBlur: _cache[15] || (_cache[15] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 12}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { class: "delivery-general-check-key-row" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 8}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("WTW:")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            xs: {span: 24},
                            sm: {span: 24},
                            md: {span: 24},
                            lg: {span: 16}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                type: "number",
                                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating || !_unref(lastInstallmentPaid),
                                value: _unref(deliveryStore)().delivery.general_checks.receivers.wtw,
                                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.receivers.wtw) = $event)),
                                onBlur: _cache[17] || (_cache[17] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                              }, null, 8, ["disabled", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "Ten behoeve van herstel gebreken stelt koper sleutel(s) ter beschikking aan de hoofdaannemer. Dit geschiedt op eigen risico en initiatief van de koper.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.keys_left,
        onValueChanged: _cache[18] || (_cache[18] = ($event: any) => (valueChanged('keys_left', $event)))
      }, null, 8, ["currentValue"]),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "Koper is ervan op de hoogte dat het Woonwenkenboek, de revisietekeningen, gebruikershandleidingen en onderhoudsadviezen op Woonon zijn te raadplegen en te downloaden.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.woonon_downloads,
        onValueChanged: _cache[19] || (_cache[19] = ($event: any) => (valueChanged('woonon_downloads', $event)))
      }, null, 8, ["currentValue"]),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "Indien van toepassing: kopers is geïnformeerd over het juiste gebruik van de loze leiding.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.empty_pipe,
        onValueChanged: _cache[20] || (_cache[20] = ($event: any) => (valueChanged('empty_pipe', $event)))
      }, null, 8, ["currentValue"]),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "In de woning of berging zijn reservetegels achtergelaten om herstel in de toekomst door Thunnissen mogelijk te maken. De reservetegels mogen niet voor andere worden gebruikt.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.spare_tiles,
        onValueChanged: _cache[21] || (_cache[21] = ($event: any) => (valueChanged('spare_tiles', $event)))
      }, null, 8, ["currentValue"]),
      (_unref(deliveryStore)().delivery.general_checks.spare_tiles)
        ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 18, offset: 6},
                sm: {span: 18, offset: 6},
                md: {span: 18, offset: 6},
                lg: {span: 22, offset: 2}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: [32, 16] }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        xs: {span: 24},
                        sm: {span: 24},
                        md: {span: 24},
                        lg: {span: 12}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { class: "delivery-general-check-key-row no-mb" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: {span: 24},
                                sm: {span: 24},
                                md: {span: 24},
                                lg: {span: 8}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Aantal:")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, {
                                xs: {span: 24},
                                sm: {span: 24},
                                md: {span: 24},
                                lg: {span: 16}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    type: "number",
                                    disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                                    value: _unref(deliveryStore)().delivery.general_checks.spare_tiles_amount,
                                    "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.spare_tiles_amount) = $event)),
                                    onBlur: _cache[23] || (_cache[23] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
                                  }, null, 8, ["disabled", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 6},
            sm: {span: 6},
            md: {span: 6},
            lg: {span: 2}
          }),
          _createVNode(_component_a_col, {
            xs: {span: 18},
            sm: {span: 18},
            md: {span: 18},
            lg: {span: 22}
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_a_select, {
                style: {"width":"200px"},
                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                value: _unref(deliveryStore)().delivery.general_checks.weather,
                "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.weather) = $event)),
                onChange: _cache[25] || (_cache[25] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "zonnig" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Zonnig")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "regen" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Regen")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "buien" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Buien")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "hagel" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Hagel")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "sneeuw" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Sneeuw")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "lichtbewolkt" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Lichtbewolkt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "bewolkt" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bewolkt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "halfbewolkt" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Halfbewolkt")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "zwaarbewolkt" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Zwaarbewolkt")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled", "value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 6},
            sm: {span: 6},
            md: {span: 6},
            lg: {span: 2}
          }),
          _createVNode(_component_a_col, {
            xs: {span: 18},
            sm: {span: 18},
            md: {span: 18},
            lg: {span: 22}
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_a_textarea, {
                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                value: _unref(deliveryStore)().delivery.general_checks.weather_description,
                "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.weather_description) = $event)),
                onBlur: _cache[27] || (_cache[27] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
              }, null, 8, ["disabled", "value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: {span: 6},
            sm: {span: 6},
            md: {span: 6},
            lg: {span: 2}
          }),
          _createVNode(_component_a_col, {
            xs: {span: 18},
            sm: {span: 18},
            md: {span: 18},
            lg: {span: 22}
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_a_textarea, {
                disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                value: _unref(deliveryStore)().delivery.general_checks.note,
                "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_unref(deliveryStore)().delivery.general_checks.note) = $event)),
                onBlur: _cache[29] || (_cache[29] = ($event: any) => (_unref(deliveryStore)().updateDelivery('general_checks', _unref(deliveryStore)().delivery.general_checks)))
              }, null, 8, ["disabled", "value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(DeliveryGeneralCheckRow, {
        label: "Koper heeft bovenstaande algemene controlepunten gelezen en gaat hiermee akkoord.",
        currentValue: _unref(deliveryStore)().delivery.general_checks.flyer_provided,
        onValueChanged: _cache[30] || (_cache[30] = ($event: any) => (valueChanged('flyer_provided', $event)))
      }, null, 8, ["currentValue"])
    ]),
    _: 1
  }))
}
}

})